import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=859e9e44&"
import script from "./NovoUsuario.vue?vue&type=script&lang=js&"
export * from "./NovoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports